import { render, staticRenderFns } from "./p04.vue?vue&type=template&id=77cd91a8&scoped=true&"
import script from "./p04.vue?vue&type=script&lang=js&"
export * from "./p04.vue?vue&type=script&lang=js&"
import style0 from "./p04.vue?vue&type=style&index=0&id=77cd91a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cd91a8",
  null
  
)

export default component.exports